import { SUPPORTED_LOCALES } from '../i18n/config';

/** Public Keiba Arena URL（`/arena/keiba`、言語付きは `/en/arena/keiba` 等） */
export function keibaArenaPublicPath(locale: string): string {
  if (locale === 'ja' || locale.startsWith('ja-')) return '/arena/keiba';
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    return `/${locale}/arena/keiba`;
  }
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) {
    return `/${short}/arena/keiba`;
  }
  return '/arena/keiba';
}

/**
 * レガシー / 誤 ja 接頭辞だけを正規 URL へ寄せる。
 * i18n.language は使わない（Googlebot の navigator=en で /arena/keiba → /en/arena/keiba になるため）。
 */
export function keibaArenaCanonicalRedirect(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/keiba-arena' || path === '/ja/keiba-arena' || path === '/ja/arena/keiba') {
    return '/arena/keiba';
  }
  const legacyLocale = path.match(/^\/([^/]+)\/keiba-arena$/);
  const loc = legacyLocale?.[1];
  if (loc && loc !== 'ja' && (SUPPORTED_LOCALES as readonly string[]).includes(loc)) {
    return `/${loc}/arena/keiba`;
  }
  return null;
}

export function isKeibaArenaPublicPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/arena/keiba' || path === '/keiba-arena') return true;
  // あきお専用ハッシュURL入力（ログイン不要）
  if (/^\/arena\/keiba\/akio\/[^/]+$/.test(path)) return true;
  return SUPPORTED_LOCALES.some(
    (loc) => path === `/${loc}/arena/keiba` || path === `/${loc}/keiba-arena`
  );
}
